import { render, staticRenderFns } from "./PriceFormatter.vue?vue&type=template&id=555675b2&functional=true"
import script from "./PriceFormatter.vue?vue&type=script&lang=js"
export * from "./PriceFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports